// custom typefaces
import 'firacode';

require('prism-solarized-dark/prism-solarizeddark.css');
